import clsx from 'clsx';
import { DEFAULT_LOADER_LABEL } from './LogoLoader.consts';
import {
  DoubleCcPart1,
  SvgWrapper,
  DoubleCcPart2,
  DoubleCcPart3,
  DoubleCcPart4,
  FatInfinity,
  DoubleGroup,
  FatGroup,
} from './Svg/CcLogo/LogoSvgPieces';
import './LogoLoader.scss';

interface Props {
  width?: number | undefined;
  isLoading?: boolean;
  className?: string;
  label?: string;
}

function LogoLoader({
  className,
  isLoading = true,
  width,
  label = DEFAULT_LOADER_LABEL,
}: Props) {
  if (!isLoading) {
    return null;
  }

  return (
    <SvgWrapper
      className={clsx(['logo-loader', className])}
      style={width ? { '--loader-width': `${width}px` } : {}}
      role="status"
      aria-label={label}
    >
      <DoubleGroup>
        <DoubleCcPart1 className="logo-loader__logo-part-1" />
        <DoubleCcPart2 className="logo-loader__logo-part-2" />
        <DoubleCcPart3 className="logo-loader__logo-part-3" />
        <DoubleCcPart4 className="logo-loader__logo-part-4" />
      </DoubleGroup>
      <FatGroup>
        <FatInfinity className="logo-loader__inifinity" />
      </FatGroup>
    </SvgWrapper>
  );
}

export default LogoLoader;
